












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'ExcelPasteHint'
})
export default class extends Vue {
  @Prop({ default: true }) public visible!: boolean;

  closeHint() {
    this.$emit('close');
  }
}
